import * as React from 'react';

import { DeliveryMessageInfo } from '../OrderRequest/interface';
import BottomDialogCustomBody, {
  BottomDialog
} from '../BottomDialogCustomBody';

import './index.css';
import { PopupViewAnimation } from '../PopupViewAnimation';

type BottomDialogSelfDeliveryProps = BottomDialog & {
  visible: boolean;
  data: DeliveryMessageInfo;
}

const BottomDialogSelfDelivery: React.FC<BottomDialogSelfDeliveryProps> = ({
  visible,
  data,
  btnText,
  onClose,
  didMountCb
}) => {
  if (!visible || !data?.title || !data?.detailList) {
    return null;
  }

  return (
    <PopupViewAnimation
      type="modal"
    >
      <BottomDialogCustomBody
        title={data.title}
        btnText={btnText}
        onClose={onClose}
        didMountCb={didMountCb}
      >
        <view className="list">
          {
            data?.detailList?.map(({
              icon,
              title,
              content
            }, index) => (
              <view className="item" key={index}>
                <image className="icon" resizeMode="widthFix" src={icon} />

                <view className="text">
                  <text className="sub-title" content={title} />
                  <text className="content" content={content} />
                </view>
              </view>
            ))
          }
        </view>
      </BottomDialogCustomBody>
    </PopupViewAnimation>
  );
};

export default BottomDialogSelfDelivery;
